module.exports = __webpack_public_path__ + "img/informatica-main.5ccccfc2.jpg";